import {
  AdditionalInfoFormFields,
  EmplaymentDetailsFormFields,
  PersonalDataFormFields,
} from 'redux/models/fieldsModel';

export const enum EventName {
  phone_number = 'phone_number',
  personal_data = 'personal_data',
  employment_details = 'employment_details',
  additional_info = 'additional_info',
  aadhaar_verification_start = 'aadhaar_verification_start',
  aadhaar_verification_success = 'aadhaar_verification_success',
  bank_account_ifsc_verification = 'bank_card_1',
  bank_account_verification = 'bank_card_2',
  bank_account_verification3 = 'bank_card_3',
  upload_docs = 'upload_docs',
  upload_docs_oz = 'upload_docs_oz',
  confirmation_conditions = 'confirmation_conditions',
  decision_application = 'decision_application',
  request_money = 'request_money',
  reject_money = 'reject_money',
  auto_debit = 'auto_debit',
  sign_sanction_letter_start = 'sign_sanction_letter_start',
  sign_sanction_letter_success = 'sign_sanction_letter_success',
  sign_loan_agreement_aadhaar_start = 'sign_loan_agreement_aadhaar_start',
  sign_loan_agreement_aadhaar_success = 'sign_loan_agreement_aadhaar_success',
  sign_loan_agreement_otp_start = 'sign_loan_agreement_otp_start',
  sign_loan_agreement_otp_success = 'sign_loan_agreement_otp_success',
  sign_loan_alternate_esign_flow_start = 'sign_loan_alternate_esign_flow_start',
  sign_loan_alternate_esign_flow_success = 'sign_loan_alternate_esign_flow_success',
  sign_loan_repeated_start = 'sign_loan_repeated_start',
  sign_loan_repeated_success = 'sign_loan_repeated_success',
  repay = 'repay',
  copy_payment_link = 'copy_payment_link',
  phone_confirmation = 'phone_confirmation',
  promo_code = 'promo_code',
  sign_contract = 'sign_contact',
}

export function findFormNameByField(value: string): string | undefined {
  for (const key in PersonalDataFormFields) {
    if (PersonalDataFormFields[key as keyof typeof PersonalDataFormFields] === value) {
      return EventName.personal_data;
    }
  }

  for (const key in EmplaymentDetailsFormFields) {
    if (EmplaymentDetailsFormFields[key as keyof typeof EmplaymentDetailsFormFields] === value) {
      return EventName.employment_details;
    }
  }

  for (const key in AdditionalInfoFormFields) {
    if (AdditionalInfoFormFields[key as keyof typeof AdditionalInfoFormFields] === value) {
      return EventName.additional_info;
    }
  }

  return undefined;
}
